import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Bell } from "lucide-react";

export const NotificationsTab = ({ notifications }) => {
  return (
    <Card className="border-border/50" data-testid="notifications-panel">
      <CardHeader>
        <CardTitle className="font-mono flex items-center gap-2">
          <Bell className="w-5 h-5" />
          Notifications
        </CardTitle>
      </CardHeader>
      <CardContent>
        {notifications.length === 0 ? (
          <p className="text-muted-foreground font-mono text-sm text-center py-8">
            No notifications yet
          </p>
        ) : (
          <div className="space-y-2">
            {notifications.map((n) => (
              <div
                key={n.id}
                className={`p-3 rounded-lg font-mono text-sm flex items-start gap-3 ${
                  n.read
                    ? 'bg-muted/20'
                    : 'bg-primary/10 border border-primary/30'
                }`}
              >
                <div
                  className={`w-2 h-2 rounded-full mt-1.5 flex-shrink-0 ${
                    n.read ? 'bg-muted-foreground/30' : 'bg-primary'
                  }`}
                />
                <div className="flex-1">
                  <p className="text-foreground">{n.message}</p>
                  <p className="text-xs text-muted-foreground mt-1">
                    {new Date(n.created_at).toLocaleString()}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
